/* =========================================================================
   SAMSARA — SECTION-PRODUCT-REVEAL.JS
   Sprint 3 / T4+T6+T7+T8 — Shared reveal IO observer pentru sections cu
   stagger animation (brewing methods + narrative sections).

   Pattern: când section intră în viewport (threshold 0.2), adaugă
   `.is-revealed` pe section root → CSS triggers stagger reveal.

   Targets: [data-product-brewing], [data-product-narrative]
   prefers-reduced-motion: reveal imediat fără animation (CSS handle).
   ========================================================================= */

(function () {
  'use strict';

  const SELECTOR = '[data-product-brewing], [data-product-narrative]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ioSupported = typeof IntersectionObserver !== 'undefined';
  const designMode = window.Shopify && window.Shopify.designMode;

  function revealNow(el) { el.classList.add('is-revealed'); }

  let observer = null;
  if (ioSupported && !reducedMotion) {
    observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        });
      },
      /* Threshold 0 + rootMargin -5% bottom: triggers when any pixel of the
         section enters viewport (minus 5% bottom edge buffer). Previous 0.2
         threshold failed on tall sections (about-story) whose max
         intersectionRatio is capped at viewport/section ratio. */
      { threshold: 0, rootMargin: '0px 0px -5% 0px' }
    );
  }

  function attach(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const targets = scope.querySelectorAll(SELECTOR);
    targets.forEach(function (t) {
      if (t.classList.contains('is-revealed')) return;
      if (!observer || designMode) { revealNow(t); return; }
      observer.observe(t);
    });
  }

  attach(document);

  /* Safety net: after 3s, force-reveal anything still hidden. Guards against
     edge cases where the observer never fires (tall sections, layout shifts,
     deferred renders). Content must never stay invisible to the user. */
  setTimeout(function () {
    document.querySelectorAll(SELECTOR).forEach(function (t) {
      if (!t.classList.contains('is-revealed')) revealNow(t);
    });
  }, 3000);

  if (designMode) {
    document.addEventListener('shopify:section:load', function (e) { attach(e.target); });
    document.addEventListener('shopify:section:select', function (e) { attach(e.target); });
  }
})();
